import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-footer',
  styleUrls: ['./ui-footer.component.scss'],
  templateUrl: './ui-footer.component.html'
})
export class UiFooterComponent {
  @Input() dark = false;
  year = new Date().getFullYear();
}
